const tooltips = {
    default: [
        {
            titleKey: "tooltip_qr_scanner_title",
            descriptionKey: "tooltip_qr_scanner_desc"
        },
        {
            titleKey: "tooltip_vip_personal_invoice_title",
            descriptionKey: "tooltip_vip_personal_invoice_desc"
        },
        {
            titleKey: "tooltip_notifications_title",
            descriptionKey: "tooltip_notifications_desc"
        },
        {
            titleKey: "tooltip_product_choice_title",
            descriptionKey: "tooltip_product_choice_desc"
        },
        {
            titleKey: "tooltip_cart_contents_title",
            descriptionKey: "tooltip_cart_contents_desc"
        },
        {
            titleKey: "tooltip_cart_modification_title",
            descriptionKey: "tooltip_cart_modification_desc"
        },
        {
            titleKey: "tooltip_summary_title",
            descriptionKey: "tooltip_summary_desc"
        },
        {
            titleKey: "tooltip_whole_cart_modification_title",
            descriptionKey: "tooltip_whole_cart_modification_desc"
        },
        {
            titleKey: "tooltip_start_payment_title",
            descriptionKey: "tooltip_start_payment_desc"
        },
        {
            titleKey: "tooltip_open_items_title",
            descriptionKey: "tooltip_open_items_desc"
        },
        {
            titleKey: "tooltip_functions_title",
            descriptionKey: "tooltip_functions_desc"
        },
        {
            titleKey: "tooltip_module_selection_title",
            descriptionKey: "tooltip_module_selection_desc"
        },
        {
            titleKey: "tooltip_cart_contents_modify_title",
            descriptionKey: "tooltip_cart_contents_modify_desc"
        },
        {
            titleKey: "tooltip_product_functions_title",
            descriptionKey: "tooltip_product_functions_desc"
        },
        {
            titleKey: "tooltip_whole_cart_modification_alt_title",
            descriptionKey: "tooltip_whole_cart_modification_alt_desc"
        },
        {
            titleKey: "tooltip_payment_title",
            descriptionKey: "tooltip_payment_desc"
        },
    ],

    table: [
        {
            titleKey: "tooltip_table_bookings_title",
            descriptionKey: "tooltip_table_bookings_desc",
            title: "Manage upcoming table bookings",
            description: "This is a brief description of the bookings component."
        },
        {
            titleKey: "tooltip_table_alt_title",
            descriptionKey: "tooltip_table_alt_desc"
        }
    ],

    deliver: [
        {
            titleKey: "tooltip_delivery_1_title",
            descriptionKey: "tooltip_delivery_1_desc",
            title: "Delivery Tooltip 1",
            description: "Description for delivery tooltip 1."
        },
        {
            titleKey: "tooltip_delivery_2_title",
            descriptionKey: "tooltip_delivery_2_desc",
            title: "Delivery Tooltip 2",
            description: "Description for delivery tooltip 2."
        }
    ]
};

export default tooltips;